module.exports = __webpack_public_path__ + "img/21.926cb6ff.jpg";